import { Component, ViewEncapsulation, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SeatMapFacade } from '@seat-map/seat-map.facade';
import { ItineraryDetail } from '@seat-map/entities/itinerary-detail';
import { MobileDeviceService } from '@app/services/mobile-device.service';
import { AppFacade } from '@app/app.facade';

@Component({
  selector: 'app-seat-map',
  templateUrl: './seat-map.container.html',
  styleUrls: ['./seat-map.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SeatMapContainer implements OnInit {

  private itineraryId: string;
  private flightIdx: string | null;

  public itineraryDetail: ItineraryDetail;

  constructor(
    private readonly appFacade: AppFacade,
    private readonly facade: SeatMapFacade,
    private readonly location: Location,
    private readonly route: ActivatedRoute,
    private readonly mobileDeviceService: MobileDeviceService,
  ) { }

  ngOnInit(): void {
    this.appFacade.historyPop();
    this.itineraryId = this.route.snapshot.paramMap.get('itineraryId');
    this.flightIdx = this.route.snapshot.paramMap.get('flightIdx');
    if (!this.itineraryId) {
      this.location.back();
    }
    this.facade.fetchItineraryDetail(this.itineraryId, this.flightIdx ? Number(this.flightIdx) : 0);
  }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$.pipe(map(isMobileDevice => isMobileDevice));
  }

}
